export default {
  default: () => import("/codebuild/output/src1732550827/src/src/layouts/default.vue").then(m => m.default || m)
}